import React from 'react';
import {connect} from 'react-redux';
import Translate, {plainTranslate} from '../../../common/translate';
import Checkbox from './switch';
import UserRoleLine from './userRoleLine';

class UserRoles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: []
        };

        this.addNewLine = this.addNewLine.bind(this);
        this.onLineChange = this.onLineChange.bind(this);
        this.removeLine = this.removeLine.bind(this);
    }

    componentDidMount() {
        this.setState({
            value: this.props.value ? this.props.value : []
        });
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
            this.setState({
                value: this.props.value ? this.props.value : []
            });
        }
    }

    addNewLine() {
        let value = this.state.value;
        value.push({});
        this.setState({value});
        this.props.onChange(this.props.id, value);
    }

    onLineChange(id, val) {
        let value = this.state.value;
        value[id] = val;
        this.setState({value});
        this.props.onChange(this.props.id, value);
    }

    removeLine(id) {
        let value = this.state.value;
        value.splice(id, 1);
        this.setState({value});
        this.props.onChange(this.props.id, value);
    }

    render() {
        return (
            <div className="">
                {
                    this.state.value.map((line, key) => {
                        return <UserRoleLine key={key}
                                             locations={this.props.locations ? this.props.locations : []}
                                             roles={this.props.roles ? this.props.roles : []}
                                             selectedLocation={line.location ? line.location : null}
                                             selectedRoles={line.roles ? line.roles : []}
                                             onChange={(value) => this.onLineChange(key, value)}
                                             removeLine={() => this.removeLine(key)}
                        />
                    })
                }
                <button type="button" className="button-outline grey" style={{margin: '0'}} onClick={this.addNewLine}>
                    {plainTranslate(this.props.settings.locale, 'Add new location & roles')}
                </button>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    settings: state.settings
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UserRoles);
